import {connect} from "react-redux";
import MrfFinanceView from "./MrfFinanceView";
import {bindActionCreators} from "redux";
import {
    viewMaterial,
    MrfApproval,
} from "../../../services/redux/MaterialRequistionForm/action";
import { mrfViewShown } from "../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
    viewMaterialDetails: state.MaterialRequistionForm.viewMaterial,
    materialApprovalDetails: state.MaterialRequistionForm.materialApproval,
    showMrfView: state.MaterialRequistionForm.showMrfView,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            viewMaterial,
            MrfApproval,
            mrfViewShown
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MrfFinanceView);
